exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".change-class .shuttle-box {\n  width: 520px;\n}\n.change-class .el-transfer-panel {\n  width: 520px;\n}\n.change-class .el-transfer__buttons {\n  padding: 0 25px;\n}\n.change-class .el-form-item__content {\n  width: 170px;\n}\n.change-box .el-form--inline .el-form-item {\n  margin-right: 15px;\n  font-size: 0;\n}\n.change-box .el-form-item__label {\n  padding: 0;\n  margin-right: 10px;\n  font-size: 14px;\n}\n.el-form--inline .into-class.el-form-item {\n  margin-right: 0;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#00b3ee",
	"menuBg": "#1f2d52",
	"minWidth": "1190",
	"minHeight": "669.375",
	"headerHeight": "60",
	"footerHeight": "60",
	"menuText": "#dae3f2",
	"menuActiveText": "#fff",
	"subMenuActiveText": "#00b3ee",
	"sidebarWidth": "200",
	"treeWidth": "340",
	"crumbsHeight": "60"
};